type EmailLinkProps = {
  children: React.ReactNode;
  className?: string;
  href: string;
};

export function EmailLink({ children, href, className }: EmailLinkProps) {
  return (
    <a
      className={className}
      href={`mailto:${href}`}
    >
      {children}
    </a>
  );
}
